import { render, staticRenderFns } from "./FileDropzone.vue?vue&type=template&id=0f095188&scoped=true&lang=pug"
import script from "./FileDropzone.vue?vue&type=script&lang=js"
export * from "./FileDropzone.vue?vue&type=script&lang=js"
import style0 from "./FileDropzone.vue?vue&type=style&index=0&id=0f095188&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f095188",
  null
  
)

export default component.exports